module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ads"
  },
  "setAttributionView": {
    "name": "Set Attribution View",
    "class": "usage",
    "properties": {
      "attributionView": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "createAudience": {
    "name": "Create Audience",
    "class": "usage",
    "properties": {
      "network": "string",
      "type": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "modifyAudience": {
    "name": "Modify Audience",
    "class": "usage",
    "properties": {
      "error": {
        "type": "string",
        "isOptional": true
      },
      "rules": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "Created audience",
        "Created last audience",
        "Deleted audience",
        "Chose audience type",
        "Opened create audience",
        "Opened create audience from ad creation",
        "Opened specific audience creation panel",
        "Failed to create audience",
        "Opened audience contact list panel",
        "Deleted member from audience",
        "checkbox-marketing-contact"
      ],
      "network": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "sourceApp": {
        "type": "string",
        "isOptional": true
      },
      "adCreationType": {
        "type": "string",
        "isOptional": true
      },
      "isEnabled": {
        "type": "boolean",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "modifyEvent": {
    "name": "Modify Event",
    "class": "usage",
    "properties": {
      "action": [
        "Created event",
        "Toggled event",
        "Opened create event panel",
        "Deleted event",
        "Save event",
        "Clicked authorize data sync button",
        "Opened create event panel from info banner",
        "Closed info banner"
      ],
      "network": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "trigger": {
        "type": "string",
        "isOptional": true
      },
      "usingDeals": {
        "type": "boolean",
        "isOptional": true
      },
      "lifecycleStage": {
        "type": "string",
        "isOptional": true
      },
      "networkStage": {
        "type": "string",
        "isOptional": true
      },
      "isNew": {
        "type": "boolean",
        "isOptional": true
      },
      "submittedLifecycleStagesCount": {
        "type": "number",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "viewAudience": {
    "name": "View Audience",
    "class": "interaction",
    "properties": {
      "action": "string",
      "audienceType": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "onboardingStepAction": {
    "name": "Onboarding step action",
    "class": "interaction",
    "properties": {
      "action": [
        "Automatic Deauth",
        "Connect Account Button Clicked",
        "Step Change",
        "Step Skip",
        "Cancelled Wizard",
        "Completed Wizard",
        "Clicked embed tracking code settings link",
        "toggle-marketing-contact"
      ],
      "network": {
        "type": "string",
        "isOptional": true
      },
      "step": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "isEnabled": {
        "type": "boolean",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "onboardingTourAction": {
    "name": "Onboarding tour action",
    "class": "interaction",
    "properties": {
      "action": [
        "Next button clicked",
        "Previous button click",
        "Completed",
        "Skipped",
        "Clicked CTA button"
      ],
      "type": [
        "shepherd",
        "widget"
      ],
      "step": {
        "type": "string",
        "isOptional": true
      },
      "partiallyCompleted": {
        "type": "boolean",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "viewedContactList": {
    "name": "View contact list",
    "class": "interaction",
    "properties": {
      "action": [
        "Viewed contact list",
        "Clicked into contact"
      ],
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "createList": {
    "name": "Create list",
    "class": "usage",
    "properties": {
      "funnelStage": "string",
      "attributionView": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "clickedDealContact": {
    "name": "Clicked deal contact",
    "class": "usage",
    "namespace": "ads",
    "properties": {
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    }
  },
  "viewedDealList": {
    "name": "View deal list",
    "class": "interaction",
    "namespace": "ads",
    "properties": {
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    }
  },
  "leadAdWizardAction": {
    "name": "Lead ad wizard action",
    "class": "interaction",
    "properties": {
      "network": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "create-workflow",
        "create-list",
        "set-notification-emails"
      ],
      "source": [
        "native-lead-ad-creation",
        "edit-page",
        "management-panel"
      ],
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "modifyCampaign": {
    "name": "Modify Campaign",
    "class": "usage",
    "properties": {
      "action": [
        "Toggled entity status",
        "Opened Max CPC modal",
        "Closed Max CPC modal without saving",
        "Updated Max CPC",
        "Opened management panel",
        "Closed management panel without making changes",
        "Saved changes from management panel",
        "Clicked edit button",
        "Clicked edit button from management panel",
        "Clicked publish changes button",
        "Clicked view details button",
        "Created workflow for ad interaction",
        "Created active list for ad interaction",
        "Used add-on AdWords functionality to edit",
        "Used add-on AdWords functionality to create",
        "Used add-on AdWords functionality to delete",
        "Opened create window",
        "Closed create window without creating",
        "Created new children",
        "Deleted entity",
        "Clicked create list from sidepanel",
        "Clicked create workflow from sidepanel",
        "Clicked create email notification from sidepanel"
      ],
      "entityType": "string",
      "network": "string",
      "changes": {
        "type": "array",
        "isOptional": true
      },
      "accountReadOnly": {
        "type": "boolean",
        "isOptional": true
      },
      "userReadOnly": {
        "type": "boolean",
        "isOptional": true
      },
      "createdEntityCount": {
        "type": "number",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "changeColumnOrder": {
    "name": "Change column order",
    "class": "interaction",
    "properties": {
      "action": [
        "Closed modal without saving",
        "Saved new columns",
        "Opened edit columns modal",
        "Dragged and dropped columns",
        "Opened help tooltip on checkbox",
        "Opened education shepherd on selection"
      ],
      "network": "string",
      "grouping": "string",
      "column": {
        "type": "string",
        "isOptional": true
      },
      "selected": {
        "type": "array",
        "isOptional": true
      },
      "added": {
        "type": "array",
        "isOptional": true
      },
      "removed": {
        "type": "array",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "adCreationAction": {
    "name": "Ad creation action",
    "class": "interaction",
    "properties": {
      "isEnabled": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "type": "string",
      "network": "string",
      "step": {
        "type": "string",
        "isOptional": true
      },
      "error": {
        "type": "string",
        "isOptional": true
      },
      "savedAudience": {
        "type": "boolean",
        "isOptional": true
      },
      "customFieldCount": {
        "type": "number",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "adSequenceTour": {
    "name": "Ad Sequence tour",
    "class": "usage",
    "properties": {
      "action": [
        "Clicked start tour button",
        "Clicked explore on my own button",
        "Cancel or skip the tour",
        "Clicked on the next tour step button",
        "Clicked on the previous tour step button",
        "Clicked on the end tour button",
        "Completed the tour",
        "Clicked a link to take a quick tour of ad sequences"
      ],
      "network": "string",
      "step": {
        "type": "string",
        "isOptional": true
      },
      "totalTime": {
        "type": "number",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "createCampaignSuccess": {
    "name": "Create Campaign Success",
    "class": "usage",
    "properties": {
      "adCount": {
        "type": "string",
        "isOptional": true
      },
      "network": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "hasSimpleWorkflows": {
        "type": "string",
        "isOptional": true
      },
      "withSimpleWorkflowsOn": {
        "type": "string",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "createCampaign": {
    "name": "Create Campaign",
    "class": "usage",
    "properties": {
      "network": "string",
      "type": {
        "type": "string",
        "isOptional": true
      },
      "adCount": {
        "type": "number",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "trackingStatusSurveyAction": {
    "name": "Tracking Status Survey Action",
    "class": "interaction",
    "properties": {
      "action": [
        "Rendered tracking status cell on screen",
        "Displayed tracking status (on hover)",
        "Clicked \"was this helpful?\"",
        "Closed survey without submitting",
        "Opened override modal",
        "Closed override modal without overriding",
        "Overrode engagement limit",
        "Opened errors modal",
        "Opened tracking errors tooltip",
        "Clicked learn how to fix",
        "Clicked refresh tracking",
        "Clicked refresh all tracking",
        "Refresh tracking succeeded",
        "Refresh tracking failed",
        "Opened dismiss tracking error modal",
        "Closed dismiss error modal after confirming",
        "Closed dismiss error modal without dismissing"
      ],
      "status": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "isTrackingErrorsModal": {
        "type": "boolean",
        "isOptional": false
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "reportAction": {
    "name": "Report Action",
    "class": "interaction",
    "properties": {
      "action": [
        "Opened save to dashboard prompt",
        "Saved to dashboard",
        "Error saving to dashboard"
      ],
      "reportType": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "viewedConversions": {
    "name": "Viewed Conversions",
    "class": "view",
    "properties": {
      "conversions": {
        "type": "number"
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "columnTooltipAction": {
    "name": "Column tooltip action",
    "class": "interaction",
    "properties": {
      "action": [
        "Opened column tooltip",
        "Clicked learn more link"
      ],
      "column": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "trustAction": {
    "name": "Trust action",
    "class": "interaction",
    "properties": {
      "action": [
        "Untrustworthy account viewed audience type selection panel",
        "Untrustworthy account hovered over disabled audience creation option"
      ],
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "demoAction": {
    "name": "Demo action",
    "class": "usage",
    "properties": {
      "action": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "couponAction": {
    "name": "Coupon action",
    "class": "interaction",
    "properties": {
      "action": [
        "Displayed badge",
        "Displayed list",
        "Revealed coupon",
        "Dismissed coupon",
        "Clicked how to use",
        "Clicked terms",
        "Displayed banner",
        "Dismissed banner"
      ],
      "networks": {
        "type": "array",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "exportAction": {
    "name": "Export action",
    "class": "interaction",
    "properties": {
      "action": [
        "Successfully exported data",
        "Export failed",
        "Opened export modal"
      ],
      "entityType": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "accessRequestTooltip": {
    "name": "View access request tooltip",
    "class": "interaction",
    "properties": {
      "key": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "recommendationAction": {
    "name": "Recommendation action",
    "class": "interaction",
    "properties": {
      "action": [
        "Applied recommendation",
        "Dismissed recommendation",
        "Canceled apply recommendation",
        "Canceled dismiss recommendation",
        "Filtered ad accounts",
        "Filtered types"
      ],
      "recommendationType": {
        "type": "string",
        "isOptional": true
      },
      "availableAccounts": {
        "type": "number",
        "isOptional": true
      },
      "selectedAccounts": {
        "type": "number",
        "isOptional": true
      },
      "selectedType": {
        "type": "string",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "usersAndTeamsAction": {
    "name": "Users and teams filter action",
    "class": "interaction",
    "properties": {
      "action": [
        "Selects users and teams"
      ],
      "selectedType": {
        "type": "string",
        "isOptional": true
      },
      "selectedId": {
        "type": "string",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "leadSyncingAction": {
    "namespace": "ads",
    "name": "Ads Lead Syncing Action",
    "class": "interaction",
    "properties": {
      "action": "string",
      "context": {
        "type": "string",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    }
  },
  "automationTour": {
    "name": "Ads Automation Tour",
    "class": "view",
    "properties": {
      "action": [
        "Viewed ads automation tour",
        "Completed ads automation tour"
      ],
      "network": "string",
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "goalCreationAction": {
    "name": "Goal Creation",
    "class": "interaction",
    "properties": {
      "action": [
        "Clicked create goal",
        "Cancelled goal creation",
        "Finished goal creation"
      ],
      "goalType": {
        "type": "string",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "dismissGoalsShepherd": {
    "name": "Dismiss Goals Shepherd",
    "class": "view",
    "properties": {
      "action": [
        "Closed goal feature pop-up"
      ],
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "goalsTableFilter": {
    "name": "Goals Table Filtering",
    "class": "interaction",
    "properties": {
      "action": [
        "Changed goal type filter",
        "Changed end date filter",
        "Changed ad account filter",
        "Changed duration filter",
        "Changed status filter",
        "Changed progress filter"
      ],
      "goalType": {
        "type": "string",
        "isOptional": true
      },
      "startDate": {
        "type": "string",
        "isOptional": true
      },
      "endDate": {
        "type": "string",
        "isOptional": true
      },
      "adAccountList": {
        "type": "array",
        "isOptional": true
      },
      "duration": {
        "type": "array",
        "isOptional": true
      },
      "status": {
        "type": "array",
        "isOptional": true
      },
      "progressMin": {
        "type": "number",
        "isOptional": true
      },
      "progressMax": {
        "type": "number",
        "isOptional": true
      },
      "has_conversions": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string"
    },
    "namespace": "ads"
  },
  "fileManagerLib": {
    "name": "File Manager Lib",
    "class": "usage",
    "properties": {
      "componentName": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerSetPanelExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "properties": {
      "panel": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerImageOptimization": {
    "name": "Change image optimization setting",
    "class": "interaction",
    "properties": {
      "setting": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerManageFiles": {
    "name": "Manage Files",
    "class": "interaction",
    "properties": {
      "count": {
        "type": "number",
        "isOptional": true
      },
      "fileSource": {
        "type": [
          "AI_GENERATED",
          "CANVA",
          "SHUTTERSTOCK"
        ],
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerManageFolders": {
    "name": "Manage Folders",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerBrowseShutterstock": {
    "name": "Browse Shutterstock",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerAlert": {
    "name": "Alert interaction",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerBulkImport": {
    "name": "Bulk Import Images",
    "class": "interaction",
    "properties": {
      "action": "string",
      "imageCount": {
        "type": "number",
        "isOptional": true
      },
      "isImageFile": {
        "type": "boolean",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerLibErrorDisplay": {
    "name": "Error display",
    "class": "view",
    "properties": {
      "type": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerVideoOptIn": {
    "name": "video optin",
    "class": "interaction",
    "properties": {
      "hasOptedBefore": {
        "type": "boolean",
        "isOptional": true
      },
      "optInStatus": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerVideoInteraction": {
    "name": "video interaction",
    "class": "interaction",
    "properties": {
      "videoTitle": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerUpload": {
    "name": "upload file",
    "class": "interaction",
    "properties": {
      "size": {
        "type": "number",
        "isOptional": true
      },
      "errorType": {
        "type": "string",
        "isOptional": true
      },
      "statusCode": {
        "type": "number",
        "isOptional": true
      },
      "videoOptInStatus": {
        "type": "string",
        "isOptional": true
      },
      "videoDuration": {
        "type": "number",
        "isOptional": true
      },
      "videoHostingProvider": {
        "type": [
          "mux"
        ],
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerUploadDeduplication": {
    "name": "check upload duplicates",
    "class": "interaction",
    "properties": {
      "hasData": {
        "type": "boolean",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "size": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerVideoPQL": {
    "name": "Video PQL",
    "class": "interaction",
    "properties": {
      "alert": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "number",
        "isOptional": true
      },
      "quantityRemaining": {
        "type": "number",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerImageGeneration": {
    "name": "image generation",
    "class": "interaction",
    "properties": {
      "errorCount": {
        "type": "number",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "networkConnectSuccess": {
    "name": "Network Connect Success",
    "class": "interaction",
    "properties": {
      "network": "string",
      "connected": "number",
      "networkAlreadyConnected": {
        "type": "boolean",
        "isOptional": true
      },
      "userAlreadyConnected": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "ads"
  },
  "networkConnectFailure": {
    "name": "Network Connect Failure",
    "class": "interaction",
    "properties": {
      "network": "string"
    },
    "namespace": "ads"
  },
  "accountConnectSuccess": {
    "name": "Account Connect Success",
    "class": "interaction",
    "properties": {
      "network": "string",
      "available": "number",
      "selected": "number",
      "tracked": "number",
      "selectedNew": {
        "type": "number",
        "isOptional": true
      },
      "selectedMultiUser": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "ads"
  },
  "accountConnectFailure": {
    "name": "Account Connect Failure",
    "class": "interaction",
    "properties": {
      "network": "string"
    },
    "namespace": "ads"
  },
  "leadSyncConnect": {
    "name": "Lead Sync Connect",
    "class": "interaction",
    "properties": {
      "network": "string",
      "available": "number",
      "selected": "number"
    },
    "namespace": "ads"
  },
  "leadSyncDisconnect": {
    "name": "Lead Sync Disconnect",
    "class": "interaction",
    "properties": {
      "network": "string",
      "removed": "number"
    },
    "namespace": "ads"
  },
  "modifyPixel": {
    "name": "Modify pixel",
    "class": "usage",
    "properties": {
      "action": [
        "Install pixel",
        "Create pixel",
        "Opened install pixel modal",
        "Completed install pixel modal or onboarding step"
      ],
      "network": {
        "type": "string",
        "isOptional": true
      },
      "facebookPixels": {
        "type": "number",
        "isOptional": true
      },
      "linkedinPixels": {
        "type": "number",
        "isOptional": true
      },
      "adwordsPixels": {
        "type": "number",
        "isOptional": true
      },
      "context": {
        "type": [
          "install-modal",
          "onboarding"
        ],
        "isOptional": true
      }
    },
    "namespace": "ads"
  },
  "errorDisplay": {
    "name": "Error display",
    "class": "view",
    "properties": {
      "type": [
        "permissions",
        "inactive",
        "user-not-authed"
      ],
      "form": [
        "banner",
        "tooltip"
      ]
    },
    "namespace": "ads"
  },
  "errorAction": {
    "name": "Error action",
    "class": "interaction",
    "properties": {
      "type": [
        "permissions",
        "inactive"
      ],
      "action": [
        "clicked kb link"
      ]
    },
    "namespace": "ads"
  },
  "adAccountConnectAction": {
    "name": "Ad Account Connect Action",
    "class": "interaction",
    "properties": {
      "action": [
        "Opened create ad account modal",
        "Clicked create ad account"
      ],
      "network": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ads"
  },
  "helpAction": {
    "name": "Help Action",
    "class": "interaction",
    "properties": {
      "action": [
        "Clicked KB link"
      ],
      "kbArticle": {
        "type": "string"
      },
      "kbSlug": {
        "type": "string"
      },
      "kbSection": {
        "type": "string",
        "isOptional": true
      },
      "context": {
        "type": "string"
      }
    },
    "namespace": "ads"
  },
  "multiAuthAction": {
    "name": "Multi auth action",
    "class": "interaction",
    "properties": {
      "action": [
        "Clicked connect user link"
      ],
      "network": [
        "FACEBOOK",
        "ADWORDS",
        "LINKEDIN"
      ],
      "context": {
        "type": "string"
      }
    },
    "namespace": "ads"
  },
  "accountCreationAction": {
    "name": "Account Creation action",
    "class": "interaction",
    "properties": {
      "action": [
        "Shown the form for account creation",
        "Successfully submitted the form for account creation",
        "Submitted the form, but received an error",
        "Clicked the billing step button and verified",
        "Clicked the billing step button and failed verification"
      ],
      "network": {
        "type": "string",
        "isOptional": true
      },
      "errorType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ads"
  },
  "conversionsEventActions": {
    "name": "Conversions event actions",
    "class": "interaction",
    "properties": {
      "action": [
        "Clicked network selection to add a pixel",
        "Clicked on sync data toggle",
        "Clicked on the Add pixel button",
        "Clicked on the cancel button",
        "Successful FBE auth setup",
        "Failed to setup FBE auth",
        "Selected using the cookie banner option",
        "Selected not using the cookie banner option",
        "Clicked on the LDU toggle"
      ],
      "network": {
        "type": "string",
        "isOptional": true
      },
      "isSyncOn": {
        "type": "boolean",
        "isOptional": true
      },
      "isLDUEnabled": {
        "type": "boolean",
        "isOptional": true
      },
      "selectedData": {
        "type": "array",
        "isOptional": true
      },
      "error": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ads"
  }
};